<script setup lang="ts">
    import type { Schemas } from '#shopware';

    const { apiClient } = useShopwareContext();
    const sessionContextData = ref<Schemas['SalesChannelContext']>();

    const fetchSessionContext = async () => {
        try {
            return await apiClient.invoke('readContext get /context');
        } catch (error: any) {
            // Retry once on transport errors (no upstream response). HTTP error responses are deterministic — don't retry those.
            if (error?.response) throw error;
            await new Promise((resolve) => setTimeout(resolve, 150));
            return await apiClient.invoke('readContext get /context');
        }
    };

    const contextResponse = await fetchSessionContext();
    sessionContextData.value = contextResponse.data;
    usePrice({ localeCode: undefined, currencyCode: sessionContextData.value?.currency?.isoCode || '' });
    useSessionContext(sessionContextData.value);

    onMounted(() => {
        //refreshCart();
    });
</script>

<template>
    <NuxtLayout>
        <NuxtPage />
    </NuxtLayout>
</template>
